(function () {
  // Add custom code below this line
  class ProductAddonCrossSell extends HTMLElement {
    constructor() {
      super();

      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
      this.refreshCart = this.refreshCart.bind(this);
    }

    connectedCallback() {
      this.productSection = this.closest('[data-section-type="product"]');
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.quantityInput = this.productForm?.querySelector('[name="quantity"]');
      this.shippingMessage = this.querySelector(
        "[data-addon-shipping-message]",
      );

      this.productPrice = Number(this.dataset.currentVariantPrice) || 0;
      this.productAvailable = this.dataset.currentVariantAvailable === "true";
      this.addonPrice = Number(this.dataset.addonPrice) || 0;
      this.threshold = Number(this.dataset.threshold) || 0;
      this.shippingCost = Number(this.dataset.shippingCost) || 0;
      this.cartTotal = null;

      this.productSection?.addEventListener(
        "theme:variant:change",
        this.handleVariantChange,
      );
      this.quantityInput?.addEventListener("change", this.handleQuantityChange);
      document.addEventListener("theme:cart:change", this.refreshCart);

      this.hideShippingMessage();
      this.refreshCart();
    }

    disconnectedCallback() {
      this.productSection?.removeEventListener(
        "theme:variant:change",
        this.handleVariantChange,
      );
      this.quantityInput?.removeEventListener(
        "change",
        this.handleQuantityChange,
      );
      document.removeEventListener("theme:cart:change", this.refreshCart);
      this.cartRequest?.abort();
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;
      this.productPrice = Number(variant?.price) || 0;
      this.productAvailable = Boolean(variant?.available);
      this.updateShippingMessage();
    }

    handleQuantityChange() {
      this.updateShippingMessage();
    }

    async refreshCart() {
      this.cartRequest?.abort();
      this.cartRequest = new AbortController();

      try {
        const root =
          window.Shopify?.routes?.root || window.theme?.routes?.root || "/";
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: "application/json" },
          signal: this.cartRequest.signal,
        });

        if (!response.ok) throw new Error("Cart request failed");

        const cart = await response.json();
        this.cartTotal = Number(cart.total_price) || 0;
        this.updateShippingMessage();
      } catch (error) {
        if (error.name !== "AbortError") {
          this.cartTotal = null;
          this.hideShippingMessage();
        }
      }
    }

    updateShippingMessage() {
      if (
        !this.shippingMessage ||
        !this.productAvailable ||
        this.cartTotal === null
      ) {
        this.hideShippingMessage();
        return;
      }

      const quantity = Math.max(Number(this.quantityInput?.value) || 1, 1);
      const projectedSubtotal = this.cartTotal + this.productPrice * quantity;
      const projectedWithAddon = projectedSubtotal + this.addonPrice;
      const qualifiesWithAddon =
        projectedSubtotal < this.threshold &&
        projectedWithAddon >= this.threshold;

      if (!qualifiesWithAddon) {
        this.hideShippingMessage();
        return;
      }

      const effectiveAddonPrice = Math.max(
        this.addonPrice - this.shippingCost,
        0,
      );
      const formattedPrice = this.formatMoney(effectiveAddonPrice);

      this.shippingMessage.textContent = this.dataset.messageTemplate.replace(
        "__AMOUNT__",
        formattedPrice,
      );
      this.shippingMessage.hidden = false;
    }

    hideShippingMessage() {
      if (!this.shippingMessage) return;

      this.shippingMessage.hidden = true;
      this.shippingMessage.textContent = "";
    }

    formatMoney(cents) {
      if (
        window.themeVendor?.themeCurrency?.formatMoney &&
        window.theme?.moneyFormat
      ) {
        return window.themeVendor.themeCurrency.formatMoney(
          cents,
          window.theme.moneyFormat,
        );
      }

      return new Intl.NumberFormat(document.documentElement.lang || "en-ZA", {
        style: "currency",
        currency: window.Shopify?.currency?.active || "ZAR",
      }).format(cents / 100);
    }
  }

  if (!customElements.get("product-addon-cross-sell")) {
    customElements.define("product-addon-cross-sell", ProductAddonCrossSell);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
